import { Translated } from './translation';

export enum BaseErrorCode {
  UnexpectedError = 'UnexpectedError'
}

export const baseErrorMessages: Record<BaseErrorCode, Translated> = {
  [BaseErrorCode.UnexpectedError]: (t) => t('Sorry, something went wrong. Please try again later.')
};
